// Keep the selected colour in the native Shopify variant field.
class AynaCartElephant extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    this.addEventListener('change', event => {
      if (!event.target.matches?.('[data-elephant-variant]')) return;
      const input = this.querySelector('input[name="id"]');
      const option = event.target.selectedOptions[0];
      if (!input || !option) return;
      input.value = option.value;
      this.querySelector('.ayna-cart-elephant__price').textContent = option.dataset.offerLabel;
      this.querySelector('.ayna-cart-elephant__regular').textContent = option.dataset.standaloneLabel;
    }, { signal: this.controller.signal });
  }
  disconnectedCallback() { this.controller?.abort(); }
}
if (!customElements.get('ayna-cart-elephant')) customElements.define('ayna-cart-elephant', AynaCartElephant);
